import { AlertCircle, Check } from 'lucide-react'
import type React from 'react'
import { Spinner } from '@/components/ui/spinner'
import { useTranslation } from '@/hooks/useTranslation'

export type TranscriptSaveStatus = 'idle' | 'saving' | 'saved' | 'error'

interface TranscriptSaveStatusIndicatorProps {
	saveStatus?: TranscriptSaveStatus
	className?: string
}

export const TranscriptSaveStatusIndicator: React.FC<TranscriptSaveStatusIndicatorProps> = ({
	saveStatus = 'saved',
	className = '',
}) => {
	const { t } = useTranslation()

	const getStatusDisplay = () => {
		switch (saveStatus) {
			case 'saving':
				return {
					icon: <Spinner className="h-3.5 w-3.5" />,
					label: t('pages.projectDetail.transcript.saveStatus.saving'),
				}
			case 'saved':
				return {
					icon: <Check className="h-3.5 w-3.5 text-green-600" aria-hidden />,
					label: t('pages.projectDetail.transcript.saveStatus.saved'),
				}
			case 'error':
				return {
					icon: <AlertCircle className="h-3.5 w-3.5 text-red-600" aria-hidden />,
					label: t('pages.projectDetail.transcript.saveStatus.error'),
				}
			default:
				return {
					icon: <AlertCircle className="h-3.5 w-3.5 text-amber-600" aria-hidden />,
					label: t('pages.projectDetail.transcript.saveStatus.unsaved'),
				}
		}
	}

	const statusDisplay = getStatusDisplay()

	return (
		<div className={`flex items-center gap-2 ${className}`}>
			{statusDisplay.icon}
			<span className="whitespace-nowrap text-xs font-medium text-gray-700">
				{statusDisplay.label}
			</span>
		</div>
	)
}
